export interface TrackedCertificate {
  certification_instance_id: number;
  request_id: number;
  request_status_id: number;
  status_color_id: number;
  certification_name: string;
  version: number;
  organization_name: string;
  template_name: string;
  assignment_created?: string;
  phase_name?: string;
  steps_count?: number;
}

export interface TrackedCertificatesResponse {
  count: number;
  rows: TrackedCertificate[];
}

export class Filters {
  page = 1;
  search = '';
}
